// actions.js

import axios from 'axios';
import { API_BASE_URL } from './config';

export const fetchHealthInfo = (kitID) => async (dispatch) => {
  dispatch({ type: 'FETCH_HEALTH_INFO_REQUEST' }); // Dispatch loading action
  try {
    const response = await axios.get(`${API_BASE_URL}/getHealthInByKitId?kit_id=${kitID}`);
    dispatch({ type: 'FETCH_HEALTH_INFO_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_HEALTH_INFO_FAILURE', payload: errorMessage });
  }

};

export const fetchGeneInfo = (HealthTraitId, kit_id) => async (dispatch) => {
  dispatch({ type: 'FETCH_GENE_INFO_REQUEST' }); // Dispatch loading action
  try {
    const response = await axios.get(`${API_BASE_URL}/getHealthGeneByKitId?health_trait_id=${HealthTraitId}&kit_id=${kit_id}`);
    dispatch({ type: 'FETCH_GENE_INFO_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_GENE_INFO_FAILURE', payload: errorMessage });
  }
};

export const fetchBlastOffRuleResult = () => async (dispatch) => {
  dispatch({ type: 'FETCH_BLASTOFF_RULE_REQUEST' }); // Dispatch loading action
  try {
    const response = await axios.get(`${API_BASE_URL}/getBlastOffRuleResult`);
    dispatch({ type: 'FETCH_BLASTOFF_RULE_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_BLASTOFF_RULE_FAILURE', payload: errorMessage });
  }
};
// export const fetchBlastOffReferenceResult = (HealthTraitId) => async (dispatch) => {
//   dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_REQUEST' }); // Dispatch loading action
//   try {
//     const response = await axios.get(`${API_BASE_URL}/getHealthReferenceByHealthTrait?health_trait_id=${HealthTraitId}`);
//     dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_SUCCESS', payload: response.data });
//   } catch (error) {
//     const errorMessage = handleError(error);
//     dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_FAILURE', payload: errorMessage });
//   }
// };

export const fetchBlastOffReferenceResult = (HealthTraitId) => async (dispatch) => {
  dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_REQUEST' }); // Dispatch loading action
  try {
    const response = await axios.get(`${API_BASE_URL}/getHealthReferenceByHealthTrait?health_trait_id=${HealthTraitId}`);
    dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_SUCCESS', payload: response.data });
  } catch (error) {
    let errorMessage;
    if (error.response && error.response.status === 404) {
      errorMessage = 'Health trait not found.';
    } else {
      errorMessage = handleError(error);
    }
    dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_FAILURE', payload: errorMessage });
  }
};

export const fetchBlastOffDietRecommendation = (kit_id) => async (dispatch) => {
  dispatch({ type: 'FETCH_BLASTOFF_DIET_REQUEST' }); // Dispatch loading action
  try {
    const response = await axios.get(`${API_BASE_URL}/geDietRecommendation?kit_id=${kit_id}`);
    dispatch({ type: 'FETCH_BLASTOFF_DIET_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_BLASTOFF_DIET_FAILURE', payload: errorMessage });
  }
};

// export const postPetSurvey = (surveyData) => async (dispatch) => {
//   dispatch({ type: 'POST_PET_SURVEY_REQUEST' }); // Dispatch loading action
//   try {
//     const response = await axios.post(`${API_BASE_URL}/postpetsurvey`, surveyData);
//     dispatch({ type: 'POST_PET_SURVEY_SUCCESS', payload: response.data });
//   } catch (error) {
//     const errorMessage = handleError(error);
//     dispatch({ type: 'POST_PET_SURVEY_FAILURE', payload: errorMessage });
//   }
// };
export const postPetSurvey = (formData) => async (dispatch) => {
  dispatch({ type: 'POST_PET_SURVEY_REQUEST' });
  try {
    const response = await axios.post(`${API_BASE_URL}/postpetsurvey`, formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
    dispatch({ type: 'POST_PET_SURVEY_SUCCESS', payload: response.data });
    return response.data; // ✅ Return the response here
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'POST_PET_SURVEY_FAILURE', payload: errorMessage });
    throw error; // Optional: rethrow for catch block in component
  }
};


// Redux Thunk
export const getPetSurvey = (email_id) => async (dispatch) => {
  dispatch({ type: 'GET_PET_SURVEY_REQUEST' });

  try {
    const response = await axios.get(`${API_BASE_URL}/getSurveyByEmail`, {
      params: { email: email_id },
    });

    dispatch({ type: 'GET_PET_SURVEY_SUCCESS', payload: response.data });
    return response.data;
} catch (error) {
  if (error.response?.status === 404) {
    console.warn("Survey not found for email:", email_id);
  }
  const errorMessage = handleError(error);
  dispatch({ type: 'GET_PET_SURVEY_FAILURE', payload: errorMessage });
}
};

export const getPetSurveyByKitEmail = (email_id, kit_id) => async (dispatch) => {
  dispatch({ type: 'GET_PET_SURVEY_REQUEST' });

  try {
    const response = await axios.get(`${API_BASE_URL}/getSurveyByEmailAndKit`, {
      params: { email: email_id, kitId: kit_id },
    });

    dispatch({ type: 'GET_PET_SURVEY_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      console.warn("Survey not found for email and kit ID:", email_id, kit_id);
    }
    const errorMessage = handleError(error);
    dispatch({ type: 'GET_PET_SURVEY_FAILURE', payload: errorMessage });
  }
};

export const updateSurveyImage = (kitId, imgBase64) => async (dispatch) => {
  dispatch({ type: 'UPDATE_SURVEY_IMAGE_REQUEST' });
  console.log("Updating survey image for kitId:", `${API_BASE_URL}/updateSurveyImage`);
  try {
    const response = await axios.post(`${API_BASE_URL}/updateSurveyImage`, {
      Kit_id: kitId,
      imgBase64: imgBase64,
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    console.log("API response:", response.data);

    dispatch({ type: 'UPDATE_SURVEY_IMAGE_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'UPDATE_SURVEY_IMAGE_FAILURE', payload: errorMessage });
    throw error;
  }
};

export const getDuplicateKitidCheck = (kitId) => async (dispatch) => {
  dispatch({ type: 'DUPLICATE_KITID_CHECK_REQUEST' });
  try {
    const response = await axios.get(`${API_BASE_URL}/getDuplicateKitidCheck`, {
      params: { kitId: kitId },
    });

    dispatch({ type: 'DUPLICATE_KITID_CHECK_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'DUPLICATE_KITID_CHECK_FAILURE', payload: errorMessage });
    throw error;
  }
};

// Function to handle different error codes
const handleError = (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        return 'Bad Request (400). Please check your input.';
      case 401:
        return 'Unauthorized (401). Please log in.';
      case 404:
        return 'Resource not found (404).';
      case 500:
        return 'Internal Server Error (500). Please try again later.';
      default:
        return `Error: ${error.response.status} - ${error.response.statusText}`;
    }
  } else if (error.request) {
    return 'No response received from the server.';
  } else {
    return `Error: ${error.message}`;
  }
};



